import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	nonPlaceholdersSegmentTooltipText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholdersSegmentTooltipText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noRelatedWorkText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	nonPlaceholdersSegmentTooltipText: {
		id: 'version-progress.related-work-progress-bar.non-placeholders-segment-tooltip-text',
		defaultMessage: '{numNonPlaceholders} added',
		description: 'Tooltip for the non-placeholders segment of the progress bar in version page.',
	},
	placeholdersSegmentTooltipText: {
		id: 'version-progress.related-work-progress-bar.placeholders-segment-tooltip-text',
		defaultMessage:
			'{numPlaceholders} {numPlaceholders, plural, one {placeholder} other {placeholders}}',
		description: 'Tooltip for the placeholders segment of the progress bar in version page.',
	},
	noRelatedWorkText: {
		id: 'version-progress.related-work-progress-bar.no-related-work-text',
		defaultMessage: 'No related work',
		description: 'Text for no related work in progress bar in version page.',
	},
});
export default messages;
